export const environment = {
  production: false,
  clientID: "4b20225f-945e-4c1e-bd98-f0a00fc6c82d", //APSL SPA Client ID
  tenantID: "d9c395e0-3a18-4633-a271-d6923c1f7486", //APSL SPA Tenant ID
  redirectUrl: "https://uat-timesheet.aurigeneservices.com/landing", //staging instance
  logoutUrl: "https://uat-timesheet.aurigeneservices.com/", //staging instance
  apiBaseUrl:
    "https://uat-timesheet.aurigeneservices.com/api/v1/" /* Staging instance */,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts